import AreaService from '../../services/models/AreaService';
import { ADD_POLY, REMOVE_PREVIEW_AREA, SET_PREVIEW_AREAS, PUSH_PREVIEW_AREA, UPDATE_AREAS, DELETE_AREA, UPDATE_AREA, SET_POLYS_BACKUP, GET_POLYS, POP_POLY, PUSH_AREA, PUSH_POLY, REMOVE_LAST_POLY, SAVE_AREA, SAVE_EDITED_AREAS, SET_AREAS, SET_CENTER_MAP, SET_POLYS, SET_ZOOM, DELETE_AREAS, SAVE_KM, GET_TABLE_AREAS, SET_MAPPAGE } from "../mutations";


const areaService = AreaService.build();

export default {

    namespaced: true,

    state: {

        areas: [],
        polygons_render_backup: [],
        polygons_render: [],
        map: { center: { lat: -22.576493, lng: -48.527000 }, zoom: 5 },
        preview_areas: [],
        mapPage: 1


    },

    getters: {

        polygons_render: state => state.polygons_render,
        polygons_render_backup: state => state.polygons_render_backup,
        areas: state => state.areas,
        map: state => state.map,
        preview_areas: state => state.preview_areas,
        mapPage: state => state.mapPage,

    },

    mutations: {

        [PUSH_PREVIEW_AREA]: (state, areaData) => {

            return state.preview_areas.push(areaData)

        },

        [SET_PREVIEW_AREAS]: (state, areasData) => {

            state.preview_areas = areasData

        },

        [PUSH_POLY]: (state, polyData) => {

            return state.polygons_render.push(polyData)


        },

        [PUSH_AREA]: (state, areaData) => {

            return state.areas.push(areaData)


        },

        [POP_POLY]: (state) => {

            return state.polygons_render.pop()

        },

        [SET_POLYS]: (state, polysData) => {

            state.polygons_render = polysData

        },
        [SET_AREAS]: (state, areasData) => {

            state.areas = areasData

        },
        [SET_POLYS_BACKUP]: (state, polysData) => {

            state.polygons_render_backup = [...polysData]

        },

        [SET_CENTER_MAP]: (state, coords) => {

            state.map.center = coords

        },

        [SET_ZOOM]: (state, zoom) => {

            state.map.zoom = zoom

        },
        [SET_MAPPAGE]: (state, newPage) => {

            state.mapPage = newPage

        },


    },

    actions: {

        [SAVE_AREA]: async function (context, areaData) {

            try {

                return await areaService.save(areaData);

            } catch (error) {

                console.log(error)
                throw error

            }

        },

        [SAVE_EDITED_AREAS]: async function ({ state }) {

            const indexArray = []

            for (const [index, polygon] of state.polygons_render.entries()) {

                for (const coordEdited of polygon) {

                    const check = state.areas[index].polygon.coordinates[0].some(coord => coordEdited.lat === coord[1] && coordEdited.lng === coord[0])

                    if (!check) {

                        indexArray.push(index)
                        break

                    }
                }
            }

            if (!indexArray.length) return false

            const toUpdate = indexArray.map(index => ({ id: state.areas[index]._id, newPolygon: state.polygons_render[index] }))

            return await areaService.updateMapEditedAreas(toUpdate);

        },

        [DELETE_AREAS]: async (context, areas) => {

            try {

                return await areaService.deleteAreas(areas)

            } catch (error) {

                console.log(error)
                throw error

            }

        },

        [GET_TABLE_AREAS]: async ({ commit }, dataToSearch) => {

            try {

                const areas = await areaService.getAreasById(dataToSearch.page, dataToSearch.id, dataToSearch.cities)

                return commit(SET_AREAS, areas);

            } catch (error) {

                console.log(error)
                throw error

            }

        },

        [DELETE_AREA]: async (context, areaId) => {

            try {

                return await areaService.deleteArea(areaId)

            } catch (error) {

                console.log(error)
                throw error

            }

        },

        [UPDATE_AREAS]: async (context, areasData) => {

            try {

                return await areaService.updateMany(areasData);

            } catch (error) {

                console.log(error)
                throw error

            }

        },

        [UPDATE_AREA]: async (context, areasData) => {

            try {

                return await areaService.update(areasData)

            } catch (error) {

                console.log(error)
                throw error

            }

        },

        [ADD_POLY]: async function ({ commit }, polyData) {

            commit(PUSH_POLY, polyData)

        },

        [REMOVE_LAST_POLY]: async function ({ commit }) {

            commit(POP_POLY)

        },

        [GET_POLYS]: async function ({ commit }, mapData) {

            const areas = await areaService.getAreasMap(mapData.page, mapData.id);

            commit(`ProviderVuex/${SET_AREAS}`, areas.rows, { root: true });

            commit(SET_POLYS, areas.mapRows)

            commit(SET_AREAS, areas.rows)

            return areas
        },

        [SAVE_KM]: async (context, uploadData) => {

            const form = new FormData()

            form.append('file', uploadData.km)
            form.append('name', uploadData.name)

            try {

                return await areaService.uploadKM(form, uploadData.id);


            } catch (error) {

                console.log(error)

                throw error

            }


        },

        [REMOVE_PREVIEW_AREA]: async ({ state, commit }, toRemoveData) => {

            const newPreviewData = state.preview_areas.filter(area => !toRemoveData.some(toRemoveArea => area.tempId === toRemoveArea.tempId))

            commit(SET_PREVIEW_AREAS, newPreviewData)

            return true


        },

    }

}